import { render, staticRenderFns } from "./WalletRolesNew.vue?vue&type=template&id=0c456be1&"
import script from "./WalletRolesNew.vue?vue&type=script&lang=ts&"
export * from "./WalletRolesNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports